export type CalSlug = '30min' | '10min'

type CalStatus = 'idle' | 'loading' | 'ready' | 'failed'

type CalFunction = ((...args: unknown[]) => void) & {
  loaded?: boolean
  ns?: Record<string, unknown>
  q?: unknown[]
}

declare global {
  interface Window {
    Cal?: CalFunction
  }
}

const EMBED_SRC = 'https://app.cal.com/embed/embed.js'
const LOAD_TIMEOUT_MS = 8000

let status: CalStatus = 'idle'

export const calUrl = (slug: CalSlug) => `https://cal.com/markvcoaching/${slug}`
export const calLink = (slug: CalSlug) => `markvcoaching/${slug}`
export const calConfig = JSON.stringify({ theme: 'dark' })

/**
 * Official Cal.com embed snippet. Runs once and appends embed.js to <head>.
 */
export function initCal() {
  if (typeof window === 'undefined' || status !== 'idle') return
  status = 'loading'

  /* eslint-disable */
  ;(function (C: any, A: string, L: string) {
    let p = function (a: any, ar: any) {
      a.q.push(ar)
    }
    let d = C.document
    C.Cal =
      C.Cal ||
      function () {
        let cal = C.Cal
        let ar = arguments
        if (!cal.loaded) {
          cal.ns = {}
          cal.q = cal.q || []
          d.head.appendChild(d.createElement('script')).src = A
          cal.loaded = true
        }
        if (ar[0] === L) {
          const api: any = function () {
            p(api, arguments)
          }
          const namespace = ar[1]
          api.q = api.q || []
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api
            p(cal.ns[namespace], ar)
            p(cal, ['initNamespace', namespace])
          } else p(cal, ar)
          return
        }
        p(cal, ar)
      }
  })(window, EMBED_SRC, 'init')
  /* eslint-enable */

  window.Cal?.('init', { origin: 'https://cal.com' })
  window.Cal?.('ui', {
    theme: 'dark',
    cssVarsPerTheme: { dark: { 'cal-brand': '#D4A24C' } },
    hideEventTypeDetails: false,
    layout: 'month_view',
  })

  const script = document.querySelector<HTMLScriptElement>(
    `script[src="${EMBED_SRC}"]`,
  )
  if (!script) {
    status = 'failed'
    return
  }
  script.addEventListener('load', () => {
    status = 'ready'
  })
  script.addEventListener('error', () => {
    status = 'failed'
  })
  window.setTimeout(() => {
    if (status === 'loading') status = 'failed'
  }, LOAD_TIMEOUT_MS)
}

export function isCalReady() {
  return status === 'ready'
}
